import moment from 'moment'

import { themeV5 } from 'theme/v5'

export const barGraphFormatter = (state, { payload }) => {
  if (!payload?.dataPoints) {
    return state
  }

  const {
    graphName,
    dataPoints = [],
  } = payload

  const statusConfigs = [
    { key: 'overdue', label: 'Overdue', color: themeV5.palette.accent.blue },
    { key: 'matured', label: 'Matured', color: themeV5.palette.accent.blue },
    { key: 'expired', label: 'Expired', color: themeV5.palette.accent.blue },
  ]

  const statusItems = statusConfigs
    .filter(({ key }) => Boolean(payload[key]))
    .map(({ key, label, color }) => ({
      ...(payload[key] || {}),
      type: key,
      label,
      color,
    }))

  const regularItems = dataPoints.map((node) => ({
    ...node,
    type: 'regular',
    color: themeV5.palette.accent.teal,
  }))

  const combinedItems = [...statusItems, ...regularItems]

  const useSingleColor = graphName === 'graphVehicleEmissions'
  const singleColor = themeV5.palette.accent.teal

  const colors = []
  const labels = []
  const ranges = []
  const values = []
  const valuesStacked = []

  const getMonth = (date) => [moment(date).format('MMM')]

  const createRange = (date) =>
    moment(date).add(1, 'months')
      .date(1)

  const createRangeHistory = () =>
    moment().subtract(20, 'years')
      .date(1)

  combinedItems.forEach((item) => {
    const numericCount = Number(item.count)
    const numericStacked = Number(item.countStacked)

    if (useSingleColor) {
      colors.push(singleColor)
    } else {
      colors.push(item.color || themeV5.palette.accent.teal)
    }

    if (item.type === 'regular') {
      const monthLabel = item.date ? getMonth(item.date) : '-'
      labels.push(monthLabel)
      ranges.push(item.date ? createRange(item.date) : createRangeHistory())
    } else {
      labels.push(item.label)
      ranges.push(createRangeHistory())
    }

    values.push(Number.isFinite(numericCount) ? numericCount : 0)

    if (Number.isFinite(numericStacked) && numericStacked > -1) {
      valuesStacked.push(numericStacked)
    }
  })

  return {
    ...state,
    data: {
      colors,
      labels,
      ranges,
      values,
      valuesStacked,
    },
  }
}
